import { Card, CardContent, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { ResponsiveText } from "../../shared/ResponsiveText";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { getWebLink } from "../../shared/PaymentAPI";
import { useEffect, useState } from "react";
import { TEXT_HEADING_NAME } from "../../shared/types";
import { PAYMENT_MESSAGES } from "../../shared/messages";
import { PaymentState } from "../../shared/Constants";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { appCache } from "../../../../cache/appCache";

interface PaymentStatusProps {
  view: string;
}
export const PaymentStatus = ({ view }: PaymentStatusProps) => {
  const navigate = useNavigate();
  const { poId } = useParams();

  const [webLink, setWebLink] = useState<string | undefined>();

  useEffect(() => {
    if (view === "backpressed") {
      const fetchWebLink = async () => {
        if (!poId) return;
        const link = await getWebLink(poId); // or "PO12345" if hardcoded
        setWebLink(link);

        if (link) {
          console.log("Payment link:", link);
        } else {
          console.log("Failed to fetch payment link");
        }
      };
      fetchWebLink();
    } else if (view === "CHARGED") {
      // dues changed: the dashboard refetches on its next visit
      appCache.invalidate("dashboard");
      //Enable to print the receipt
    }
  }, [poId]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" marginTop="20px">
      <Card elevation={0} sx={{ p: 4, borderRadius: 3, border: "1px solid #e5e7eb", boxShadow: "0 12px 40px rgba(16, 24, 40, 0.08)", width: { xs: "calc(100% - 32px)", md: "500px" }, maxWidth: 500 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          {view === PaymentState.INITIATING_PAYMENT ? (
            <>
              <AutorenewIcon sx={{ fontSize: 60, color: "orange", animation: "spin 2s linear infinite" }} />
              <Typography variant="h5" mt={2}>
                Initiating Payment
              </Typography>
            </>
          ) : (
            ""
          )}
          {"backpressed" === view ? (
            <>
              <ErrorOutlineIcon sx={{ fontSize: 60, color: "red" }} />
              <ResponsiveText headingName={TEXT_HEADING_NAME.PAYMENT_FAILED_HEADING} text={PAYMENT_MESSAGES.PAYMENT_IN_PROGRESS} />
              <Typography variant="body2" color="text.secondary" mt={1}>
                If you want to complete the payment please click <a href={webLink}>here</a>.
              </Typography>
              <Button variant="contained" fullWidth sx={{ mt: 4, borderRadius: 2 }} size="small" onClick={() => navigate("/app/fees/outstanding")}>
                View Dues
              </Button>
            </>
          ) : (
            ""
          )}
          {view === "CHARGED" ? (
            <>
              <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "green" }} />
              <Typography variant="h5" mt={2}>
                Payment Successful
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Thank you! Your transaction was completed successfully.
              </Typography>
              <Button variant="contained" fullWidth size="small" sx={{ mt: 4, borderRadius: 2 }} onClick={() => navigate("/app/fees/receipts")}>
                View Receipts
              </Button>
            </>
          ) : (
            ""
          )}
          {view === "PENDING" ? (
            <>
              <HourglassEmptyIcon sx={{ fontSize: 60, color: "orange" }} />
              <Typography variant="h5" mt={2}>
                Payment Processing
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Your transaction is pending. Please do not retry the payment — check the payment status in the Payments page.
              </Typography>
              <Button variant="contained" fullWidth size="small" sx={{ mt: 4, borderRadius: 2 }} onClick={() => navigate("/app/fees/payments")}>
                View Payments
              </Button>
            </>
          ) : (
            ""
          )}
          {view === "unknown" ? (
            <>
              <>
                <ErrorOutlineIcon sx={{ fontSize: 60, color: "red" }} />
                <Typography variant="h5" mt={2}>
                  Status Unknown
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1}>
                  Please contact admin.
                </Typography>
                <Button variant="contained" fullWidth size="small" sx={{ mt: 4, borderRadius: 2 }} onClick={() => navigate("/app/fees/outstanding")}>
                  View Dues
                </Button>
              </>
            </>
          ) : (
            ""
          )}
        </Box>
      </Card>
    </Box>
  );
};
